import { motion, AnimatePresence } from 'framer-motion';
import { Calendar, Phone } from 'lucide-react';
import { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import siteConfig from '@/config/siteConfig';

export const FloatingRDVButton = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling 500px
      setIsVisible(window.scrollY > 500);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ opacity: 0, scale: 0.8, x: 100 }}
          animate={{ opacity: 1, scale: 1, x: 0 }}
          exit={{ opacity: 0, scale: 0.8, x: 100 }}
          className="fixed bottom-6 right-6 z-50"
        >
          <div 
            className="relative"
            onMouseEnter={() => setIsExpanded(true)}
            onMouseLeave={() => setIsExpanded(false)}
          >
            {/* Expanded state */}
            <AnimatePresence>
              {isExpanded && (
                <motion.div
                  initial={{ opacity: 0, x: 20, width: 0 }}
                  animate={{ opacity: 1, x: 0, width: 'auto' }}
                  exit={{ opacity: 0, x: 20, width: 0 }}
                  className="absolute right-full mr-3 top-1/2 -translate-y-1/2 whitespace-nowrap"
                >
                  <span className="bg-background/95 backdrop-blur-sm text-foreground px-4 py-2 rounded-full text-sm font-body shadow-lg border border-accent/30">
                    Réserver un appel gratuit
                  </span>
                </motion.div>
              )}
            </AnimatePresence>

            {/* Main Button */}
            <a 
              href={siteConfig.rdvClarityLink} 
              target="_blank" 
              rel="noopener noreferrer"
              data-testid="floating-rdv-btn"
            >
              <motion.div
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.95 }}
                className="relative"
              >
                {/* Pulse animation ring */}
                <motion.div
                  className="absolute inset-0 rounded-full bg-accent"
                  animate={{ 
                    scale: [1, 1.3, 1],
                    opacity: [0.5, 0, 0.5]
                  }}
                  transition={{ 
                    duration: 2,
                    repeat: Infinity,
                    ease: "easeInOut"
                  }}
                />
                
                {/* Button */}
                <Button 
                  className="btn-gold rounded-full w-14 h-14 p-0 shadow-gold-intense"
                >
                  <Calendar className="w-6 h-6" />
                </Button>
              </motion.div>
            </a>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default FloatingRDVButton;
